import React from 'react'

import cx from 'classnames'

import { Toggle } from '@driftt/tide-core'

import styles from './styles.module.css'
import utilityStyles from 'conversations/css/utility.module.css'

interface InvertedToggleBlockProps {
  title: string
  checked: boolean
  description: React.ReactNode
  onToggle: (e: any) => void
  'data-ocweb-id': string
}

const InvertedToggleBlock: React.FC<InvertedToggleBlockProps> = ({
  title,
  checked,
  onToggle,
  description,
  'data-ocweb-id': dataOcwebId,
}) => {
  return (
    <div className={styles.toggleBlock} onClick={onToggle}>
      <div>
        <div>{title}</div>
        <p
          className={cx(
            utilityStyles.smFontSize,
            utilityStyles.darkGrayColor,
            styles.toggleDescription
          )}>
          {description}
        </p>
      </div>
      <div data-ocweb-id={dataOcwebId} className={styles.toggleColumn}>
        <Toggle size={'small'} className={styles.toggle} checked={checked} onChange={onToggle} />
      </div>
    </div>
  )
}

export default InvertedToggleBlock
